/**
 * @file
 *
 * Adds 'indicator' class on share results webform checkbox.
 */

'use strict';
(function ($, Drupal) {
  // This behavior adds indicator class on webform share results checkbox.
  Drupal.behaviors.webform = {
    attach: (context, settings) => {
      const formClass = '.field--type-webform';
      const checkboxClass = '.form-checkbox';
      const indicatorClass = 'indicator';
      $(formClass).find(checkboxClass).each(function() {
        if (!$(this).next().hasClass(indicatorClass)) {
          $(this).after(`<div class="${indicatorClass}"></div>`);
        }
      });
    }
  }

})(jQuery, Drupal);
